// JavaScript dependencies
require('@popperjs/core');
const bootstrap = require('bootstrap')
window.bootstrap = bootstrap // set window.bootstrap to make bootstrap-select work
require("owl.carousel");
require("holderjs");
require("magnific-popup");
require("ally.js");

// Custom JavaScript
require('./js/nosun-main');
require('./js/cookies');
require('./js/default');
require('./js/custom');

// Style sheets
require('./scss/main.scss');
